import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'react-bootstrap';
import { useAuth } from '@/shared/contexts/AuthContext';
import './PolicyPage.css';

// One date for all three pages: they were written together and are reviewed
// together, so a change to one is a change to the set.
export const POLICIES_LAST_UPDATED = 'September 29, 2026';

/**
 * The role address a reader writes to about a policy.
 *
 * It comes from the public sign-in config, so it is absent for the first
 * round trip and stays absent if that read fails. The fallback still tells
 * the reader where to look rather than rendering a mailto with no address.
 */
export function SupportAddress() {
    const { supportEmail } = useAuth();
    if (!supportEmail) {
        return <>the address in the footer of every page</>;
    }
    return <a href={`mailto:${supportEmail}`}>{supportEmail}</a>;
}

/**
 * Shared frame for the privacy, terms, and accessibility pages.
 *
 * Each page sets its own tab title with usePageTitle rather than this frame
 * doing it: the route-page guard in usePageTitle.test.js checks the page
 * files App.js imports, and a title set one level down is invisible to it.
 *
 * Headings inside a policy start at h2: the page has exactly one h1, and the
 * footer's own headings are h2/h3, so a section at h3 or below would break
 * the heading order axe checks.
 */
function PolicyPage({ title, summary, children }) {
    return (
        <Container className="py-5 afe-policy">
            <h1>{title}</h1>
            <p className="text-muted">Last updated {POLICIES_LAST_UPDATED}</p>
            <p className="afe-policy-draft">
                The exchange is a pilot. This page is under review by the
                partner institutions and may change before the exchange opens
                campus-wide.
            </p>
            {summary && <p className="lead">{summary}</p>}
            {children}
        </Container>
    );
}

PolicyPage.propTypes = {
    title: PropTypes.string.isRequired,
    summary: PropTypes.node,
    children: PropTypes.node.isRequired,
};

export default PolicyPage;
